import mirror from 'keymirror';

export const QuestionsActionConstants = mirror({
  QUESTIONS_RECEIVED: null
});

export const SubmissionActionConstants = mirror({
  LOADING_SUBMISSION: null,
  SKIP_QUESTION: null,
  SUBMISSION_RECEIVED: null
});

export const QUIZ_API_URL = '/api/quiz/'

export const URLS = {
  slideshow: '/lionel-1st-bday/slideshow/'
}

export const IMGS = {
  lionel_1bday: '/static/images/lionel-1bday.jpg'
}


// WEBPACK FOOTER //
// ./src/constants/index.js